import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { getCryptoTableExportFileName } from '../../../../api/rs-hg/crypto';
import AssetLevelTable from './AssetLevelTable.component';
import type { CryptoFundTableRow } from './cryptoPage.types';

const AssetLevelTableWrapper = (exportPositionDate?: string) => [
  (rowData: CryptoFundTableRow) => {
    const assets = rowData.assets ?? [];
    const icon = () => (assets.length ? <KeyboardArrowRight /> : <></>);
    const exportFileName =
      exportPositionDate && rowData.fundId
        ? getCryptoTableExportFileName(
            `asset_level-${rowData.fundId}`,
            exportPositionDate,
          )
        : undefined;
    const render = () => (
      <AssetLevelTable data={assets} exportFileName={exportFileName} />
    );
    return {
      disabled: !assets.length,
      icon,
      openIcon: KeyboardArrowDown,
      render,
    };
  },
];

export default AssetLevelTableWrapper;
